import { lazy } from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { RoutePath } from './router.config';
import AppLayout from 'Layout/AppLayout/AppLayout';
import ErrorPageLayout from 'Layout/ErrorPageLayout/ErrorPageLayout';
import ContactDataStep from 'pages/ContactDataStep/ContactDataStep';
import Registration from 'Layout/Registration/Registration';
import AppSecondaryLayout from 'Layout/AppSecondaryLayout';
import RouterErrorBoundary from './router.errorboundary';

const SignupPDV = lazy(() => import('../pages/SignupPDV'));
const PersonalDataStep = lazy(
  () => import('../pages/PersonalDataStep/PersonalDataStep'),
);
const SecurityDataStep = lazy(
  () => import('../pages/SecurityDataStep/SecurityDataStep'),
);
const EmailConfirmation = lazy(() => import('../pages/EmailConfirmation'));
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));
const InternalServerError = lazy(
  () => import('../pages/InternalServerError/InternalServerError'),
);
export const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    ErrorBoundary: RouterErrorBoundary,
    children: [
      {
        path: `${RoutePath.Root}`,
        element: <Registration />,
        children: [
          {
            index: true,
            element: <ContactDataStep />,
          },
          {
            path: RoutePath.PersonalData,
            element: <PersonalDataStep />,
          },
          {
            path: RoutePath.SecurityData,
            element: <SecurityDataStep />,
          },
        ],
      },
      {
        path: RoutePath.SignumConfirmationEmail,
        element: <EmailConfirmation />,
      },
    ],
  },
  {
    element: <AppSecondaryLayout />,
    ErrorBoundary: RouterErrorBoundary,
    children: [
      {
        path: RoutePath.SignupPDV,
        element: <SignupPDV />,
      },
    ],
  },
  {
    element: <ErrorPageLayout />,
    children: [
      {
        path: RoutePath.Oops,
        element: <InternalServerError />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

const router = createBrowserRouter(routes, {
  basename: import.meta.env.BASE_URL,
});

export default router;
